import $ from 'jquery'

$(window).on('load resize', () => {
    const $cards = $('.swiper')
    $cards.css('height', '')
    const heights = $cards.map((i, el) => $(el).height())
    const maxHeight = Math.max.apply(null, heights)
    $cards.css('height', maxHeight)
})